import React from 'react';
import { connect } from 'react-redux'
import { Spin, Button  } from 'antd';
import {AdmsRepository} from '../../redux/AdmsActions';

/** Компонента, отображающая количество Concept-ов, у которых есть связь с http://www.w3.org/ns/adms#Asset
 * с предикатом http://www.w3.org/ns/dcat#theme. 
 * Значение количество определяется количеством http://www.w3.org/ns/adms#Asset имеющих связь
 * 
 * В начале ConceptCount отображает загрузку, в этот момент запрашивается информация о количестве , если 
 * значение найдено, то отображается найденное значение, если нет, то отображается 0 
 * 
 * Флаг waitStatistics используется для ожидание загрузки статистики в родительских компонентах
 * иначе делается запрос для получения информации 
 * */
const Loading = () => <span>(<Spin size="small" />)</span>

const Label = ({value, count, childrenCount, handlers}) => {
    //console.log("ConceptCount.js ", value, count, childrenCount, handlers)
    const intCount = parseInt((count)?(count):value) || 0;
    const label = intCount+childrenCount;
    if (intCount > 0 && typeof handlers === "function") {
        return (
        <Button
            type="link"
            size="small"
            style={{ padding: 0, height: 'auto' }}
            onClick={(e) => handlers(e)}
        >
            ({label})
        </Button>
        );
    }
    return (
        <span>({label})</span>
    )
}

/**Проверяет наличие статистики во вложенных элементах */
function hasChildrenStatistics(concept, statistics, concepts){
    return statistics && (!statistics.hasOwnProperty(concept.IRI.value) 
      || (statistics.hasOwnProperty(concept.IRI.value) && statistics[concept.IRI.value]!=0) 
      || (concept.children && concept.children.filter(
          child => hasChildrenStatistics(child, statistics, concepts)).length>0
        ));
  }

const statisticsValue = (statistics, concept) => {
    return parseInt(statistics.hasOwnProperty(concept.IRI.value)? statistics[concept.IRI.value].count: 0);
}

function countChildrenStatistics(concept, statistics){
    //console.log("countChildrenStatistics", concept, statistics, concepts);
    if (concept && concept.children){
        return concept.children
            .filter(child => hasChildrenStatistics(child, statistics, child.children))
            .reduce((partialSum, child) => partialSum + statisticsValue(statistics, child) + countChildrenStatistics(child, statistics, child.children) , 0);
    }
    return 0;
  }
  
class ConceptCount extends React.Component {

    state = {
        loaded: false,
        value: undefined
    };

    /** Вызывается сразу после монтирования компонента (вставки в дерево).  
    * см. https://legacy.reactjs.org/docs/react-component.html#componentdidmount */
    componentDidMount() {
        if (this.props.IRI)
            this.makeCount();
    };

    /** Вызывается сразу после обновления. Этот метод не вызывается для первоначального рендеринга. 
     * см. https://legacy.reactjs.org/docs/react-component.html#componentdidupdate */
    componentDidUpdate(prevProps) {
        //console.log(this, "componentDidUpdate(prevProps)", this.props.IRI);
        if (this.props.IRI){
            if ((prevProps.IRI != this.props.IRI) || !this.state.loaded)
                this.makeCount();
        } else {
            this.setState({loaded: true, value: undefined});
        };
    };

    /** вызывается прямо перед вызовом метода рендеринга, как при первоначальном монтировании, 
     * так и при последующих обновлениях. 
     * см. https://legacy.reactjs.org/docs/react-component.html#static-getderivedstatefromprops */
    // static getDerivedStateFromProps(props, state) {
    //     if (props.count==null) {
    //       return {
    //         loaded: false
    //       };
    //     }
    //     return null; // Return null to indicate no change to state.
    // }

    makeCount () {
        const {IRI, lang, graph, rfilter, conditions, statistics, waitStatistics} = this.props;
        //Если данные заданы в свойстве statistics
        const statistic = (statistics && statistics[IRI])? statistics[IRI]: undefined;
        //console.log(this, statistic);
        if (statistic !== undefined &&  statistic !== null && statistic.constructor == Object && statistic["count"] !== undefined)
            return this.setState({loaded: true, value: statistic.count, IRI});
        if (waitStatistics)
            return;
        //Здесь происходит пересчёт количества концептов по условиям  и rfilter, conditions
        this.props.onCalculate(IRI, lang, graph, rfilter, conditions)
            .then ((response) =>{
                //console.log("Done!", response);
                let {count} = response;
                this.setState({loaded: true, value: count, IRI});
            })
            .catch(e => { 
                console.error("Error!", e);
            });
    }

    render(){
        const {concept, statistics} = this.props;
        const childrenCount = (concept && Array.isArray(concept.children))
            ? countChildrenStatistics(concept, statistics): 0;
        const Component = (this.state.loaded)? Label: Loading;
        //console.log(this, childrenCount);
        return(
            <Component {...this.props} {...this.state} childrenCount = {childrenCount}/>
        )
    }
}

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vadms, vset} = state;
    //Параметры, которые могут прийти из настроек
    const {graph, IRI, lang } = props;
    const rGraph = (graph)? graph: vset.graph;
    //Получим описание свойства. В описании должно быть IRI свойства, prefix (т.е. uri xmlns), code и строковые значения
    const statistics = (vadms && vadms.statistics)?vadms.statistics[IRI]:{};
    const count = ((typeof statistics === 'undefined') || (typeof statistics["count"] === 'undefined'))? null: statistics["count"];
    return {
        graph: rGraph,
        lang: (lang)?lang: vset.lang,
        IRI,
        rfilter: vadms.rfilter,
        conditions: vadms.conditions,
        statistics: vadms.statistics,
        count,
        vset
    };
}

export default connect(
    mapStateToProps,
    dispatch => ({
        onCalculate(IRI, lang, graph, rfilter, conditions){
            return dispatch(AdmsRepository.loadTaxonomyConceptCount(IRI, lang, graph, rfilter, conditions));
        }
    })    
)(ConceptCount);